import { postJson, ApiSuccess } from './client';

export interface UnsubscribeRequest {
  slug: string;
  email: string;
  recaptchaToken: string;
}

export function submitUnsubscribe(payload: UnsubscribeRequest): Promise<ApiSuccess> {
  return postJson('/unsubscribe', payload);
}
